<template>
  <div class="home">
    <qrcode-stream
      ref="qrcode"
      :size="size"
      :paused="shouldPause"
      @decode="onDecode"
      @init="onInit"
      :track="() => false"
      :camera="camera"
      v-if="!initial">
      <div id="scanner-area-container" ref="scanner_overlay">
        <div id="scanner-border"></div>
        <div id="scanner-area" :class="{'pause': shouldPause}">
        </div>
      </div>
    </qrcode-stream>
    <div id="control-overlay">
      <a href="javascript: void(0)" id="switch-camera" @click="frontFacing = !frontFacing"></a>
      <a href="javascript: void(0)" id="counter" @click="$router.push('counter')">人工激活</a>
    </div>
    <div id="initial-overlay" :class="{'shown': initial}">
      <div id="initial-content-container" @click="playClicked">
        <div id="initial-logo" v-if="!initialLoading">&#9658;</div>
        <div class="lds-ring" v-else><div></div><div></div><div></div><div></div></div>
      </div>
    </div>
    <div id="loading-overlay" :class="{'shown': loading}">
      <div id="loading-content-container">
        <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
        <p>掃碼成功<br />發送請求至服務器...</p>
      </div>
    </div>
    <div id="success-overlay" :class="{'shown': successShown}" @click="closeSuccessMessage">
      <div id="success-content-container">
        <p class="title">激活成功</p>
        <p>{{ ticket.customer }}</p>
        <p>{{ ticketEventTitle }}</p>
        <p>{{ ticketVariantName }}</p>
        <p>激活次數: {{ ticket.activated }}</p>
      </div>
    </div>
    <div id="error-overlay" :class="{'shown': errorShown}" @click="closeErrorMessage">
      <div id="error-content-container">
        <div id="error-logo">&times;</div>
        <p>{{ errorMessage }}</p>
      </div>
    </div>
    <audio ref="beep">
      <source src="../assets/beep.wav" type="audio/wav">
    </audio>
  </div>
</template>

<script>
import { QrcodeStream } from 'vue-qrcode-reader'
import { invitation, ticket } from '@/api'

function checkid(e) {
  let patt = /^[a-f\d]{24}$/i
  return patt.test(e)
}

const delayTime = 10000;

const ticketMock = {
  "_id": "63e8f03fcfe7d6899afd1584",
  "activated": 3,
  "lastActivatedAt": "2023-02-14T16:31:00.147Z",
  "ticketVariant": {
    "_id": "63e8d1bbd2f2385168e96b22",
    "name": "test ticket",
    "price": "0.01",
    "quantity": 10,
    "event": {
      "_id": "63e8d173d2f2385168e96b0f",
      "_updateTime": "2023-02-13T07:55:25.129Z",
      "title": "Test Event",
      "description": "Test Event",
      "startTime": "2023-02-08T13:00:00.000Z",
      "maxPerOrder": 1,
      "entities": [],
      "shop": "63e63af601b5ae8ac986e7ff",
      "shopProductId": "8115760824627",
      "__v": 0,
      "image": "https://cdn.shopify.com/s/files/1/0724/8304/5683/products/WechatIMG942.jpg?v=1676274929",
      "preview": "https://cdn.shopify.com/s/files/1/0724/8304/5683/products/cn-1015-1472380-1812775-front_1.jpg?v=1676274910",
      "id": "63e8d173d2f2385168e96b0f"
    },
    "shopProductVariantId": "44399540863283",
    "__v": 0
  },
  "customer": "ChanJeffrey +8613543263574",
  "shopCustomerId": "6774505603379",
  "shopOrderId": "5262475919667",
  "__v": 0
};

export default {
  name: 'home',
  data() {
    return {
      ticket: {},

      frontFacing: false,
      initial: true,
      initialLoading: false,

      loading: false,
      errorShown: false,
      successShown: false,
      errorMessage: null,

      timer: null,
      size: null
    }
  },
  watch: {
    size() {
      this.setBorder()
    }
  },
  methods: {
    playClicked() {
      if (!this.initialLoading) {
        this.initialLoading = true
        this.$refs.beep.play().finally(() => this.initial = false);
        this.$refs.beep.pause();
      }
    },
    closeErrorMessage() {
      this.errorShown = false
      clearTimeout(this.timer)
    },
    closeSuccessMessage() {
      this.successShown = false
      clearTimeout(this.timer)
    },
    showError(message) {
      this.loading = false
      this.errorMessage = message
      this.errorShown = true
      this.timer = setTimeout(() => this.errorShown = false, delayTime)
    },
    showSuccess(ticket, timer=10000) {
      console.log(ticket);

      this.ticket = ticket;
      this.loading = false
      this.successShown = true

      if (timer) {
        this.timer = setTimeout(() => this.successShown = false, timer)
      }
    },

    onDecode(e) {
      this.$refs.beep.play()

      this.loading = true
      this.successShown = false
      this.errorShown = false
      clearTimeout(this.timer)

      if (!checkid(e)) {
        this.showError('無效邀請碼')
        return;
      }

      ticket.activate(e).then(({ data: ticket }) => {
        if (ticket.activated > 1) throw new Error('已激活過');
        this.showSuccess(ticket);
      }).catch((err) => {
        this.showError(err.message);
      })
    },
    setBorder() {
      let videoEl = this.$refs.qrcode.cameraInstance.videoEl
      let width = videoEl.clientWidth, height = videoEl.clientHeight
      let size = Math.floor(window.innerWidth / 2)
      let top_border = (height - size)/2, left_border = (width - size)/2

      let overlay = this.$refs.scanner_overlay
      overlay.style.borderTop = `${top_border}px solid`
      overlay.style.borderBottom = `${top_border}px solid`
      overlay.style.borderLeft = `${left_border}px solid`
      overlay.style.borderRight = `${left_border}px solid`
      overlay.style.opacity = 1;
    },
    async onInit (promise) {
      try {
        await promise

        let height = window.innerHeight
        let videoEl = this.$refs.qrcode.cameraInstance.videoEl
        videoEl.style.height = height + "px"
        this.$refs.qrcode.$refs.pauseFrame.style.height = height + "px"

        let ratio = height / videoEl.videoHeight
        this.size = Math.floor((window.innerWidth / 2) / ratio);

      } catch (error) {
        if (error.name === 'NotAllowedError') {
          // user denied camera access permisson
        } else if (error.name === 'NotFoundError') {
          // no suitable camera device installed
        } else if (error.name === 'NotSupportedError') {
          // page is not served over HTTPS (or localhost)
        } else if (error.name === 'NotReadableError') {
          // maybe camera is already in use
        } else if (error.name === 'OverconstrainedError') {
          // passed constraints don't match any camera.
          // Did you requested the front camera although there is none?
        } else if (error.name === 'StreamApiNotSupportedError') {
          // browser seems to be lacking features
        }
      } finally {
        // hide loading indicator
      }
    }
  },

  computed: {
    ticketEventTitle() {
      if (this.ticket.ticketVariant && this.ticket.ticketVariant.event) {
        return this.ticket.ticketVariant.event.title;
      }
      return '';
    },
    ticketVariantName() {
      if (this.ticket.ticketVariant) {
        return this.ticket.ticketVariant.name;
      }
      return '';
    },
    shouldPause() {
      return (this.loading || this.errorShown) || this.successShown
    },
    camera() {
      return this.frontFacing ? "auto" : "rear"
    }
  },

  components: {
    QrcodeStream,
  },
}
</script>

<style>
.qrcode-stream {
  overflow: hidden;
}
.qrcode-stream__inner-wrapper {
  max-width: none !important;
  max-height: none !important;
}
.qrcode-stream__pause-frame {
  max-width: none !important;
  height: 100%;
}
video {
  max-width: none !important;
}

*::-webkit-media-controls-panel {
  display: none!important;
  -webkit-appearance: none;
}
*::-webkit-media-controls-play-button {
  display: none!important;
  -webkit-appearance: none;
}
*::-webkit-media-controls-start-playback-button {
  display: none!important;
  -webkit-appearance: none;
}
</style>

<style scoped>
@keyframes popup {
  from {
    transform: scale(0, 0);
    opacity: 0;
  }
  to {
    transform: scale(1, 1);
    opacity: 1;
  }
}
#switch-camera {
  width: 40px;
  height: 40px;
  position: absolute;
  right: 20px;
  top: 20px;
  z-index: 10;
  background-image: url(../assets/switch_camera.svg);
  background-size: 100% auto;
  background-position: center;
  background-repeat: no-repeat;
}
#counter {
  position: absolute;
  bottom: 60px;
  left: 50%;
  transform: translateX(-50%);
  color: white;
  font-size: 22px;

  text-decoration: none;
  padding-bottom: 2px;
  border-bottom: 1px solid white;
}
#control-overlay  {
  background: transparent;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
#error-logo, #success-logo {
  margin: 0 auto;
}
#success-logo {
  font-size: 55px;
  margin-bottom : 20px;
}
#error-logo {
  height: 70px;
  width: 70px;
  font-size: 50px;
  border-radius: 50%;
  border: 3px solid white;
  margin-bottom : 30px;
}
#loading-overlay, #error-overlay, #success-overlay, #initial-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,.6);

  display: flex;
  align-items: center;
  justify-content: center;

  opacity: 0;
  pointer-events: none;
  transition: opacity .3s, transform .2s;

  z-index: 10;
}
#error-overlay, #success-overlay, #initial-overlay {
  transform: scale(0, 0);
}
#initial-overlay.shown, #loading-overlay.shown, #error-overlay.shown, #success-overlay.shown {
  opacity: 1;
  transform: scale(1,1);
  pointer-events: auto;
}
/*#loading-overlay.shown, #error-overlay.shown, #success-overlay.shown {
  animation-fill-mode: forwards;
  animation-name: popup;
  animation-duration: .3s;

  pointer-events: auto;
}*/
#initial-logo {
  font-size: 40px;
  padding: 0 10px;
}
#initial-content-container {
  padding: 10px 30px;
  background: rgba(255,255,255,.85);
  border-radius: 10px;
}
#loading-content-container {
  padding: 30px 30px 20px;
  background: rgba(255,255,255,.85);
  border-radius: 10px;
}
#error-content-container {
  padding: 30px 30px 20px;
  background: rgba(185, 18, 18, 0.85);
  border-radius: 10px;
  color: white;
  font-size: 25px;
}
#success-content-container {
  padding: 12px 20px;
  background: rgba(27, 193, 7, 0.85);
  border-radius: 10px;
  color: white;
  font-size: 18px;
}
#success-content-container .title {
  font-weight: bold;
  font-size: 22px;
  margin-bottom: 16px;
}

.home {
  height: 100%;
  width: 100%;
  background: rgba(0,0,0,.8);
}
#scanner-area-container {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  overflow: hidden;
  border-color: rgba(0,0,0, 0.9) !important;

  touch-action: manipulation;
  transition: opacity .3s;
  opacity: 0;
}
@keyframes scan {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(100%);
  }
}
@keyframes scan-grid {
  0% {
    opacity: 0.8;
  }
  100% {
    opacity: 0.2;
  }
}
#scanner-border {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border: 1px solid #099c09;
  touch-action: manipulation;
}
#scanner-area {
  width: 100%;
  height: 100%;
  position: relative;

  animation-name: scan;
  animation-duration: 2s;
  animation-iteration-count: infinite;

  touch-action: manipulation;
}
#scanner-area.pause {
  animation-play-state: paused;
}
#scanner-area:before {
  position: absolute;
  content: '';
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  animation-name: scan-grid;
  animation-duration: 2s;
  animation-iteration-count: infinite;

  background-image: repeating-linear-gradient(to bottom, transparent, transparent 10px, #099c09 10px, #099c09 11px),
                    repeating-linear-gradient(to right, transparent, transparent 10px, #099c09 10px, #099c09 11px);
}
#scanner-area:after {
  position: absolute;
  content: '';
  height: 2px;
  background: #099c09;
  width: 100%;
  top: 0;
  left: 0;
  box-shadow: 0 0 11px 4px rgba(47, 175, 31, 0.5);
}
</style>
